import { render, staticRenderFns } from "./PriceVolumeEditor.vue?vue&type=template&id=221e4440"
import script from "./PriceVolumeEditor.vue?vue&type=script&lang=js"
export * from "./PriceVolumeEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports